import {
  DEPRECATED_backwardsCompatibleValues,
  StrictLocalizeFunction,
} from "@faire/web/common/localization/localize";

export const ALL_FILTERS_INTL_TEXT = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "All Filters",
    description: { text: "Display all filter options (product/brand list)" },
  });
export const MORE_FILTERS_INTL_TEXT = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "More Filters",
    description: { text: "Display other filter options (product/brand list)" },
  });
export const SEE_MORE_INTL_TEXT = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "See More",
    description: { text: "Expand a list of filter options" },
  });
export const SEE_LESS_INTL_TEXT = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "See Less",
    description: { text: "Shrink a list of filter options" },
  });
export const CLEAR_ALL_INTL_TEXT = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Clear All",
    description: { text: "Remove all applied filters from result list" },
  });
export const APPLY_INTL_TEXT = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Apply",
    description: { text: "Apply selected filters to result list" },
  });
export const APPLY_FILTERS_INTL_TEXT = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "Apply Filters",
    description: { text: "Apply selected filters to result list" },
  });
export const SORT_BY_INTL_TEXT = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Sort By",
    description: { text: "Filter to sort a list" },
  });

export const getSearchInputPlaceholder = (
  searchLabelText: string | undefined,
  filterSectionName = "",
  strictLocalize: StrictLocalizeFunction
) => {
  if (searchLabelText) {
    return searchLabelText;
  }
  return strictLocalize(
    {
      defaultMessage: "Search for {filterSectionName}",
      description: {
        text: "Field to narrow down available filter options",
      },
    },
    DEPRECATED_backwardsCompatibleValues({ filterSectionName })
  );
};
